"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
function compileErrorStyle(branding) {
    const { error = {} } = branding;
    return (0, utils_1.process)({
        'error-color': error === null || error === void 0 ? void 0 : error.color,
        'error-font-weight': error === null || error === void 0 ? void 0 : error.fontWeight,
        'error-font-size': error === null || error === void 0 ? void 0 : error.fontSize,
        'error-line-height': error === null || error === void 0 ? void 0 : error.lineHeight,
        'error-margin': error === null || error === void 0 ? void 0 : error.margin
    });
}
exports.default = compileErrorStyle;
